<div class="st-create-new-template-container">
    <mat-icon class="material-symbols-outlined st-create-new-template-container__icon--edit"> edit </mat-icon>
    <div class="st-create-new-template-container--title">{{ languageSettings.PSTWebCreateNewTemplateLabel }}</div>
    <st-text-field
        class="st-create-new-template-container__title--input"
        [value]="newTitleValue()"
        [label]="i18n.PSTRundownName"
        (changed)="newTitleValue.set($event)" />
    <div
        class="st-create-new-template-container-buttons"
        [class.st-create-new-template-container-buttons--for-rundown]="isRundown">
        <button
            class="st-create-new-template-container-buttons__btn--cancel"
            mat-button
            (click)="closeDialog()">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>

        @if (data?.record?.Type === ObjectTypes.TOPIC) {
            @if (isSuperVisor) {
                <button
                    mat-button
                    [disabled]="isDisabled"
                    (click)="createEnterpriseTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveAsEnterprise }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
                <button
                    mat-button
                    [disabled]="isDisabled"
                    (click)="createTeamTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveAsTeam }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
                <button
                    class="st-create-new-template-container-buttons__btn--save"
                    mat-button
                    [disabled]="isDisabled"
                    (click)="createPersonalTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveButtonLabel }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
            } @else {
                <button
                    class="st-create-new-template-container-buttons__btn--save"
                    mat-button
                    [disabled]="isDisabled"
                    (click)="createPersonalTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveButtonLabel }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
            }
        } @else if (data?.record?.Type === ObjectTypes.RUNDOWN) {
            <button
                class="st-create-new-template-container-buttons__btn--save"
                mat-button
                [disabled]="isDisabled"
                (click)="createTeamTemplate($event)">
                @if (!loading()) {
                    {{ languageSettings.PSTWebSaveButtonLabel }}
                } @else {
                    <st-loader
                        class="st-login-button-group--spinner"
                        [diameter]="30"
                        [strokeWidth]="5" />
                }
            </button>
        } @else {
            @if (isSuperVisor) {
                <button
                    mat-button
                    [disabled]="isDisabled"
                    (click)="createEnterpriseTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveAsEnterprise }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
                <button
                    mat-button
                    class="st-create-new-template-container-buttons__btn--save"
                    [disabled]="isDisabled"
                    (click)="createTeamTemplate($event)">
                    @if (!loading()) {
                        {{ languageSettings.PSTWebSaveAsTeam }}
                    } @else {
                        <st-loader
                            class="st-login-button-group--spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
            }
        }
    </div>
</div>
